import React from 'react';
import styled from 'styled-components';
import SubLayout from '../components/layout/SubLayout';
import { aboutMenus } from '../data/aboutMenus';

const ImageWrapper = styled.div`
  text-align: center;
`;

const OrgImage = styled.img`
  max-width: 100%;
  height: auto;
  border: 1px solid #eee;
  border-radius: 8px;
`;

const Placeholder = styled.div`
  border: 2px dashed #ccc;
  border-radius: 8px;
  padding: 80px 40px;
  text-align: center;
  color: #aaa;
  background: #fafafa;

  p { font-size: 1rem; margin-top: 10px; }
  small { font-size: 0.85rem; color: #bbb; }
`;

const Organization = () => {
  const hasImage = false; // 조직도 이미지 준비되면 true로 변경

  return (
    <SubLayout title="조직도" sidebarMenus={aboutMenus} bannerBg="/images/bg_building.jpg">
      <ImageWrapper>
        {hasImage ? (
          <OrgImage src="/images/organization.png" alt="주식회사 두성시스템 조직도" />
        ) : (
          <Placeholder>
            <div style={{ fontSize: '3rem' }}>🏢</div>
            <p>조직도 이미지를 준비 중입니다.</p>
            <small>
              이미지 파일을 <code>/public/images/organization.png</code> 에 추가하고<br />
              이 파일의 <code>hasImage</code> 값을 <code>true</code>로 변경해주세요.
            </small>
          </Placeholder>
        )}
      </ImageWrapper>
    </SubLayout>
  );
};

export default Organization;
